import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => ({
	container: {
		width: "75px",
		position: 'absolute',
		bottom: '10px',
	},
	riddle: {
		width: "70%",
		cursor: 'pointer',
		borderRadius: '50%',
		verticalAlign: 'middle',
	},
	arrow: {
		width: '25%',
		verticalAlign: 'middle',
	},
	next: {
		right: '25px',
		"& $arrow":{
			paddingLeft: '5px'
		}
	},
	prev: {
		left: '25px',
		"& $arrow":{
			paddingRight: '5px'
		}
	},
	loading: {
		opacity: 0.4,
	},
	"@media (max-height: 500px)":{
		container: {
			bottom: "25px",
		}
	}
});

function RiddleCircleTile(props) {
	const { classes, riddle, navigationClick, direction, isLoading } = props;

	const onClick = () => {
		// if(isLoading){
		// 	return
		// }

		navigationClick(riddle, riddle.indexInRiddleList)
	};

	 const imageClass = isLoading ? [classes.riddle, classes.loading].join(' ') : classes.riddle;
	 const arrowClass = isLoading ? [classes.arrow, classes.loading].join(' ') : classes.arrow;

	if(riddle){
		return (
			<div className={[classes.container, classes[direction]].join(' ')} onClick={onClick} >
				{direction === 'prev' && <img className={classes.arrow} src={getTranslation("image_logo_navigation_previous_button")} alt="Previous riddle"/>}
				<img className={classes.riddle} src={riddle.imgWithUrl} />
				{direction === 'next' && <img className={classes.arrow} src={getTranslation("image_logo_navigation_next_button")} alt="Next riddle"/>}

			</div>
		);
	} else {
		return (
			<div className={classes.container}/>
		);
	}

}

RiddleCircleTile.propTypes = {
	isLoading: PropTypes.bool.isRequired,

	riddle: PropTypes.object,

	navigationClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(RiddleCircleTile);
